import React from 'react'
import { useAuth } from '../../context/UserContext'
import moment from 'moment'
import utils from '../../utils';

function StoreInfo() {
    const { store } = useAuth()
    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4">
                {store?.logo && (
                    <div className="md:col-span-2 flex flex-col items-center">
                        <img className='h-60 w-full object-cover object-center' src={utils.baseUrl + store?.logo} alt="" />
                    </div>
                )}
                {/* Store Name */}
                {store?.name && (
                    <div>
                        <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Store Name
                        </label>
                        <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                            {store.name}
                        </p>
                    </div>
                )}

                {/* Location */}
                {store?.location && (
                    <div>
                        <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Location
                        </label>
                        <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                            {store.location}
                        </p>
                    </div>
                )}

                {/* Created */}
                {store?.creation_time && (
                    <div>
                        <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Store Since
                        </label>
                        <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                            {moment(store.creation_time).format('MMM D, YYYY')}
                            <span className="text-gray-500 dark:text-gray-400 ml-2">
                                ({moment(store.creation_time).fromNow()})
                            </span>
                        </p>
                    </div>
                )}

                <div className="md:col-span-2">
                    <label className="text-sm font-medium text-gray-500 dark:text-gray-400 mr-2">
                        Store Status:
                    </label>
                    <p className="mt-1 inline-flex flex-wrap items-center gap-2">

                        {store?.is_active ? (
                            <span className="px-3 py-1 bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300 text-xs font-semibold rounded-full flex items-center">
                                <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <circle cx="10" cy="10" r="8" fill="currentColor" opacity="0.2" />
                                    <circle cx="10" cy="10" r="4" fill="currentColor" />
                                </svg>
                                Active
                            </span>
                        ) : (
                            <span className="px-3 py-1 bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300 text-xs font-semibold rounded-full flex items-center">
                                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                Inactive
                            </span>
                        )}

                        {/* Verified */}
                        {store?.is_verified ? (
                            <span className="px-3 py-1 bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 text-xs font-semibold rounded-full flex items-center">
                                <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                Verified
                            </span>
                        ) : (
                            <span className="px-3 py-1 bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300 text-xs font-semibold rounded-full flex items-center">
                                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                                Pending Verification
                            </span>
                        )}

                        {store?.logo && (
                            <span className="px-3 py-1 bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300 text-xs font-semibold rounded-full flex items-center">
                                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                Image Uploaded
                            </span>
                        )}

                    </p>
                </div>
                {store?.description && (
                    <div className="md:col-span-2">
                        <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            About This Store
                        </label>
                        <p className="mt-1 text-gray-800 dark:text-gray-200 whitespace-pre-line">
                            {store.description}
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default StoreInfo